import { Alert, Box } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';
import { useAdminEntityAssociationWizard } from '../../hooks/admin/useAdminEntityAssociationWizard';
import MessageToast from '../MessageToast';
import StepStatusBar from '../styles/StepStatusBar';
import StyledSection from '../styles/StyledSection';
import { StyledCard, StyledCardContent, StyledHeading, StyledTypography } from '../styles/styles';
import { AdminEntityAssociationWizardSteps } from './AdminEntityAssociationWizard/AdminEntityAssociationWizardSteps';
import {
  STEP_LABELS,
  WIZARD_STEPS,
} from './AdminEntityAssociationWizard/adminEntityAssociationWizardTypes';

export const AdminEntityAssociationWizard: React.FC = () => {
  const { investorId, selectedEntityId, currentState } = useParams();
  const {
    state,
    dismissMessage,
    handleEntitySelected,
    handleCreateNewEntity,
    handleEntityCreated,
    handleAllocationComplete,
    handleContactsComplete,
    handleComplete,
    handleAllocationBack,
    handleCreateCancel,
    handleLookupComplete,
  } = useAdminEntityAssociationWizard({
    investorId,
    selectedEntityId,
    currentState,
  });

  if (!state.investor && !state.loading) {
    return (
      <StyledSection tone="default">
        <Alert severity="error">{state.error || 'Unable to load investor information'}</Alert>
      </StyledSection>
    );
  }

  return (
    <StyledSection tone="default" noSidePaddingFrom="xs">
      <Box sx={{ margin: '0 auto', padding: 4 }}>
        <StyledHeading sx={{ mb: 2 }}>Admin: Associate Investment Entity</StyledHeading>

        <StyledTypography sx={{ mb: 4 }}>
          {state.investor?.name && (
            <>Associate an investment entity with {state.investor.name}'s investment.</>
          )}
        </StyledTypography>

        {state.message && (
          <MessageToast
            message={state.message.text}
            type={state.message.type}
            open={true}
            onClose={dismissMessage}
          />
        )}

        <StepStatusBar
          statuses={WIZARD_STEPS}
          activeStatus={state.currentStep}
          onPromote={() => {}}
          labelMap={STEP_LABELS}
          tone="tone1"
          canPromote={false}
        />

        <StyledCard>
          <StyledCardContent>
            <AdminEntityAssociationWizardSteps
              state={state}
              onLookupComplete={handleLookupComplete}
              onEntitySelected={handleEntitySelected}
              onCreateNew={handleCreateNewEntity}
              onEntityCreated={handleEntityCreated}
              onCreateCancel={handleCreateCancel}
              onAllocationComplete={handleAllocationComplete}
              onAllocationBack={handleAllocationBack}
              onContactsComplete={handleContactsComplete}
              onComplete={handleComplete}
            />
          </StyledCardContent>
        </StyledCard>
      </Box>
    </StyledSection>
  );
};
